import React from 'react'
import { H3, LayoutBand, Paragraph, Separator } from '@fs/zion-ui'

export default function CenterSupportLandingPage() {
  return (
    <LayoutBand>
      <H3>Discovery Centers Support Landing Page</H3>
      <Separator size="lg" />
      <Paragraph size="sm">
        Welcome to the Discovery Centers Support section. Support permissions are required.
      </Paragraph>
    </LayoutBand>
  )
}
